import dev.shanty.kotwire.stimulus.Controller
import dev.shanty.kotwire.stimulus.StimulusController
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLInputElement

@JsExport
@StimulusController(
    targets = ["search", "placeId", "results"],
    values = PlaceSearchController.Values::class,
)
class PlaceSearchController(context: dynamic) : Controller(context) {

    private val searchInput  by searchTarget<HTMLInputElement>()
    private val placeIdInput by placeIdTarget<HTMLInputElement>()
    private val resultsDiv   by resultsTarget<HTMLElement>()
    private val searchUrl    by searchUrlValue()

    private var debounceHandle: Int = 0

    @JsName("search")
    fun search() {
        window.clearTimeout(debounceHandle)
        debounceHandle = window.setTimeout({
            val query = searchInput.value.trim()
            if (query.length < 2) {
                hideResults()
                return@setTimeout
            }
            performSearch(query)
        }, 300)
    }

    private fun performSearch(query: String) {
        val encoded = encodeURIComponent(query)
        val url = "$searchUrl?q=$encoded"
        val p = window.asDynamic().fetch(url)
        p.then { r: dynamic -> r.json() }
         .then { data: dynamic ->
             renderResults(data)
             null
         }
         .catch { err: dynamic ->
             console.error("Place search failed", err)
             null
         }
    }

    private fun renderResults(suggestions: dynamic) {
        resultsDiv.innerHTML = ""
        val count = suggestions.length as? Int ?: 0
        if (count == 0) {
            hideResults()
            return
        }

        for (i in 0 until count) {
            val placeId = suggestions[i].placeId as String
            val text    = suggestions[i].displayText as String
            val item    = document.createElement("div")
            item.className = "px-4 py-2 cursor-pointer hover:bg-gray-100 text-sm"
            item.textContent = text
            item.addEventListener("click", { selectPlace(placeId, text) })
            resultsDiv.appendChild(item)
        }
        resultsDiv.classList.remove("hidden")
    }

    private fun selectPlace(placeId: String, displayText: String) {
        placeIdInput.value = placeId
        searchInput.value  = displayText
        hideResults()
    }

    private fun hideResults() {
        resultsDiv.innerHTML = ""
        resultsDiv.classList.add("hidden")
    }

    object Values {
        val searchUrl: String = ""
    }
}

private fun encodeURIComponent(value: String): String = js("encodeURIComponent(value)") as String
